import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import MobileBottomBar from "@/components/feature/MobileBottomBar";

export default function Pflanzen() {
  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-[500px] md:min-h-[600px] lg:min-h-[700px] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Lush%20indoor%20plant%20shop%20with%20tropical%20green%20plants%20ferns%20palms%20and%20succulents%20in%20terracotta%20pots%20warm%20natural%20light%20from%20large%20windows%20wooden%20shelves%20botanical%20garden%20atmosphere%20editorial%20photography&width=1600&height=900&seq=pflanzen-hero-001&orientation=landscape"
            alt="Pflanzen & Dekoration – Grüne Oase mit tropischen Pflanzen und Zimmergrün"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center pt-20">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 md:mb-6 max-w-4xl mx-auto leading-tight drop-shadow-lg">
            Pflanzen & Dekoration
          </h1>
          <p className="text-white/90 text-base md:text-lg lg:text-xl max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed drop-shadow-md">
            Entdecken Sie auf über 500 m² Floristik und Dekoration eine wechselnde Auswahl an Pflanzen, Naturmaterialien und Wohnideen für jeden Anlass.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-background-50 text-foreground-950 rounded-md text-sm font-medium hover:bg-white transition-colors whitespace-nowrap shadow-lg"
            >
              Manufaktur in Leer besuchen
            </Link>
            <a
              href="https://www.fleurop.de/partnerfloristen/fleurop-filialen/26789-leer/florale-manufaktur-blumen-stoehr-gmbh-heisfelder-str-105"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-3.5 border-2 border-white/80 text-white rounded-md text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap"
            >
              <i className="ri-send-plane-line w-4 h-4 flex items-center justify-center mr-2"></i>
              Blumen online über Fleurop versenden
            </a>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <main>
        <div className="max-w-4xl mx-auto px-4 md:px-6 py-16 md:py-24">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-6">
            Unsere Pflanzenwelt
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-10">
            In unserer Manufaktur finden Sie eine ständig wechselnde Auswahl an Pflanzen und Dekorationsartikeln. Von klassischen Zimmerpflanzen bis zu exotischen Raritäten – wir beraten Sie gerne bei der Auswahl und Pflege.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {[
              { icon: "ri-flower-line", title: "Frische Schnittblumen", desc: "Täglich frische Blüten direkt vom Großhandel" },
              { icon: "ri-plant-line", title: "Topfpflanzen für Innen- und Außenbereich", desc: "Grüne Begleiter für jeden Raum und Garten" },
              { icon: "ri-seedling-line", title: "Dekorierte Pflanzen", desc: "Verziert mit Naturmaterialien zum Verschenken" },
              { icon: "ri-home-4-line", title: "Saisonale Wohn- und Gartenideen", desc: "Inspiration für jedes Zuhause und jede Jahreszeit" },
              { icon: "ri-gallery-line", title: "Wechselnde Floristik-Ausstellungen", desc: "Regelmäßig neue Themen und Trendideen" },
              { icon: "ri-earth-line", title: "Regionale und importierte Blumen", desc: "Vielfältige Auswahl aus aller Welt" },
              { icon: "ri-refresh-line", title: "Regelmäßig neue Sortimentsideen", desc: "Immer aktuell mit den neuesten Trends" },
            ].map((item) => (
              <div
                key={item.title}
                className="flex items-start gap-4 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200/70"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 shrink-0">
                  <i className={`${item.icon} w-5 h-5 flex items-center justify-center text-primary-600`}></i>
                </div>
                <div>
                  <h3 className="font-medium text-foreground-950 text-sm md:text-base mb-1">
                    {item.title}
                  </h3>
                  <p className="text-foreground-600 text-sm">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Manufaktur besuchen
            </Link>
          </div>
        </div>
      </main>

      <Footer />
      <MobileBottomBar />
    </>
  );
}